export const privacyPolicyData = {
  lastUpdated: "30 Jan 2025", 
  useDate: true,
  terms: [
    {
      paragraph: [
        {
          tagType: "p",
          class: "terms-description",
          text: "This privacy policy (\"Privacy Policy\") is designed to describe Pastime-Live Inc.'s (\"Finance Razor\", \"we\", \"our\" or \"us\") data collection practices in connection with this site (together with its subdomains, features, and services available thereon, the \"Site\"), and in connection with your use or engagement with any feature, content, offer, element or service we make available to you via the Site (the \"Services\")."
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "We reserve the right, in our sole and absolute discretion, to change this Privacy Policy at any time. In which case, we will post the modified Privacy Policy on the Site, and the \"Last Updated\" statement at the top shall reflect the effective date of the modified version. Any access or use you make of the Site following such date constitutes your consent and acceptance of the modified Privacy Policy."
        }
      ]
    },
    {
      paragraph: [
        {
          tagType: "p",
          class: "terms-description",
          text: "This Privacy Policy includes:"
        },
        {
          tagType: "list",
          textList: [
            "1. Terms of Use",
            "2. Personal Information We Process",
            "3. How we use Personal information?",
            "4. How do We Share Your Information with Third Parties?",
            "5. Links to and Interaction with Third Parties",
            "6. Retention of Information",
            "7. How do we safeguard your data?",
            "8. Children's Privacy",
            "9. Contact Us"
          ]
        }
      ]
    },
    {
      paragraph: [
        {
          tagType: "h3",
          class: "terms-title",
          text: "1. Terms of Use"
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "This Privacy Policy forms an integral part of the Site's Terms of Use (the \"Terms\"). Any capitalized term in this Privacy Policy that we don't define, will have the meaning given to it in the Terms."
        }
      ]
    },
    {
      paragraph: [
        {
          tagType: "h3",
          class: "terms-title",
          text: "2. Personal Information We Process"
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "For the purposes of this Privacy Policy, \"Personal Information\" means information that may be used, either alone or in combination with other information, to personally identify an individual."
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "When you visit the Site, or use the Services we collect certain Personal Information about your visit and usage of the Site and the Services, in one or more of the following ways:"
        },
        {
          tagType: "p",
          class: "terms-medium-description",
          text: "2.1. Information You Provide to Us. Use of the Services will require you to provide certain Personal Information including full name, email address, home address, vehicle information, driving history, insurance history, birth date and other relevant insurance-related information. The specific elements collected may change based on legal or commercial requirements. If you register for a newsletter or contact us for support, we will collect your contact information, including additional information that you may choose to share as part of your interaction with the Site."
        },
        {
          tagType: "p",
          class: "terms-medium-description",
          text: "2.2. Information We Collect from You. We collect information about your use of the Services and your interaction with the Site or the Services such as device information (type and version, operating systems, language and version) and IP address, your interaction with the Site (clicks, usage time and so on)."
        },
        {
          tagType: "p",
          class: "terms-medium-description",
          text: "2.2.1. Cookies and Similar Technologies. The Site may use \"cookies\" and other anonymous web tracking technologies implemented by us or by third party service providers. A cookie is a small file containing a string of characters that is sent to your computer when you visit a website. When you visit the website again, the cookie allows that website to recognize your browser. Cookies may store your online preferences and other information about the interaction you make in the Site. You can reset your browser to refuse all cookies or to indicate when a cookie is being sent to your browser. However, some features or services, included in the Site, may not function properly without cookies, and some features may become unavailable for you in such cases."
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "Please refer to our Cookie Policy for more information about the type of cookies used and the manner in which we use cookies/tracking technologies on our Site."
        }
      ]
    },
    {
      paragraph: [
        {
          tagType: "h3",
          class: "terms-title",
          text: "3. How We Use Personal Information"
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "We use Personal Information to:"
        },
        {
          tagType: "list",
          textList: [
            "• Provide you with our insurance comparison Services",
            "• Improve our services through research and development",
            "• Communicate with you following inquiries or for marketing communications",
            "• Enforce our Terms and comply with legal obligations"
          ]
        }
      ]
    },
    {
      paragraph: [
        {
          tagType: "h3",
          class: "terms-title",
          text: "4. How do We Share Your Information with Third Parties?"
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "We do not sell Personal Information about you to third parties, except for the following circumstances:"
        },
        {
          tagType: "p",
          class: "terms-medium-description",
          text: "4.1. We may share Personal Information with our trusted third party providers, including subsidiaries and affiliates, who may be located in different jurisdictions across the world, for any of the following purposes:"
        },
        {
          tagType: "list",
          textList: [
            "• Providing you with our Service, including providing a personalized display of our Site",
            "• Storing and processing such information on our behalf",
            "• Performing research, technical diagnostics or analytics"
          ]
        },
        {
          tagType: "p",
          class: "terms-medium-description",
          text: "4.2. Partners – If you submit an insurance quote request, we will share the information with our trusted insurance Partners to provide you with coverage options and quotes based on your information. This sharing enables Partners to provide you with personalized offers and to contact you with the information you have requested. You acknowledge that the Partners may contact you as a result of submitting the request."
        },
        {
          tagType: "p",
          class: "terms-medium-description",
          text: "4.3. If you have enabled cookies on the Site, some cookies may be operated by third parties, such as social media sites which may collect your Personal Information independently. Their use of your Personal Information is governed by their respective privacy policies."
        },
        {
          tagType: "p",
          class: "terms-medium-description",
          text: "4.4. Enforcement. We may share your Personal Information with a third party if we believe that disclosure of such information is helpful or reasonably necessary to: (a) comply with any applicable law, regulation, legal process, or governmental request; (b) enforce our Terms of Use, including investigations of potential violations thereof; (c) detect, prevent, or otherwise address fraud or security issues; and/or (d) protect against harm to the rights, property or safety of Finance Razor, our affiliated entities, our users, yourself, and/or the public."
        },
        {
          tagType: "p",
          class: "terms-medium-description",
          text: "4.5. We may share information in the event of a corporate transaction (e.g. sale of a substantial part of our business, merger, consolidation or asset sale). In the event of the above, the transferee or acquiring company will assume the rights and obligations as described in this Privacy Policy."
        }
      ]
    },
    {
      paragraph: [
        {
          tagType: "h3",
          class: "terms-title",
          text: "5. Links to and Interaction with Third Parties"
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "Our policy only addresses the use and disclosure of information we collect from you. To the extent you disclose your information to other parties or sites throughout the Internet, different rules may apply to their use or disclosure of the information you disclose to them. Accordingly, we encourage you to read the terms and conditions and privacy policy of each third party that you choose to disclose information to."
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "This Privacy Policy does not apply to the practices of companies that we do not own or control, or to individuals whom we do not employ or manage, including any of the third parties which we may disclose information as set forth in this Privacy Policy."
        }
      ]
    },
    {
      paragraph: [
        {
          tagType: "h3",
          class: "terms-title",
          text: "6. Retention of Information"
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "We will retain your personal information for as long as necessary to provide our Services, and as necessary to comply with our legal obligations, resolve disputes, and enforce our policies. Retention periods will be determined taking into account the type of information that is collected and the purpose for which it is collected, bearing in mind the requirements applicable to the situation and the need to destroy outdated, unused information at the earliest reasonable time. Under applicable regulations, we will keep records containing Personal Information as required by applicable laws and regulations."
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "We may rectify, replenish or remove incomplete or inaccurate information, at any time and at our own discretion."
        }
      ]
    },
    {
      paragraph: [
        {
          tagType: "h3",
          class: "terms-title",
          text: "7. How do We Safeguard Your Data?"
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "We take great care in implementing and maintaining the security of the Site and your information. We employ industry standard procedures and policies to ensure the safety of the information we collect and retain, and prevent unauthorized use of any such information, and we require any third party to comply with similar security requirements, in accordance with this Privacy Policy. Although we take reasonable steps to safeguard information, we cannot be responsible for the acts of those who gain unauthorized access or abuse our Site, and we make no warranty, express, implied or otherwise, that we will prevent such access."
        }
      ]
    },
    {
      paragraph: [
        {
          tagType: "h3",
          class: "terms-title",
          text: "8. Children's Privacy"
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "The Site or the Services are not designed to attract users under the age of 18. Accordingly, we do not intend to collect Personal Information from anyone we know to be under 18. If we learn that we have collected Personal Information from a child under 18, we will use commercially reasonable efforts to delete that information as quickly as possible. If you believe that we might have any such information, please contact us at: support@financerazor.com."
        }
      ]
    },
    {
      paragraph: [
        {
          tagType: "h3",
          class: "terms-title",
          text: "9. Contact Us"
        },
        {
          tagType: "p",
          class: "terms-description",
          text: "We try to make this Privacy Policy simple and easy to understand. However, if you have any questions you may contact us at: support@financerazor.com."
        }
      ]
    }
  ]
};